import { useEmail, useUpdateDatabase } from "src/hooks";
import { fillInEmailTemplate } from "../utils";
import {
  RESULT_EMAIL_ADMIN,
  RESULT_EMAIL,
  RESULT_EMAIL_SUBJECT,
  ESG_SUBMITTED_FOR_VALIDATION_EMAIL,
} from "../constants/result-email";

// const ESG_FORM_EMAIL = "elearning.warsaw@gmail.com";
const ESG_FORM_EMAIL = "toby@zerobees.com";

const ESG_FORM_SUBJECT = "BIT Self Assessment Next Steps";

const useEsgEmails = () => {
  const { sendBasicEmail } = useEmail();

  const { updateDocument } = useUpdateDatabase();

  const sendEsgEmail = async ({
    respondentId,
    orgName,
    firstName,
    email,
    type,
  }) => {
    const link = `${process.env.REACT_APP_FRONTEND}/#/results/${respondentId}`;

    const template = type === "result" ? RESULT_EMAIL : RESULT_EMAIL_ADMIN;

    const filledTemplate = fillInEmailTemplate({
      template,
      orgName,
      link,
      firstName,
    });

    try {
      await sendBasicEmail({
        email,
        subject: RESULT_EMAIL_SUBJECT,
        text: filledTemplate,
      });

      await updateDocument(["esg-survey", respondentId, "entries", "self"], {
        resultEmailSent: true,
      });
    } catch (e) {
      console.log(e);
    }
  };

  const sendEsgContactEmail = async (values) => {
    const { name, email, organisation, message } = values;

    const content = {
      email: ESG_FORM_EMAIL,
      subject: ESG_FORM_SUBJECT,
      text: `Name: ${name}\nOrganisation: ${organisation}\nEmail: ${email}\n\n${message}`,
    };

    try {
      await sendBasicEmail(content);
    } catch (e) {
      console.log(e);
    }
  };

  const sendEsgSubmittedForValidationEmail = async ({
    name,
    email,
    respondentId,
  }) => {
    const subject = "BIT Self Assessment Submitted for Validation";

    const text = ESG_SUBMITTED_FOR_VALIDATION_EMAIL.replace(
      "<firstName>",
      name
    );

    try {
      await sendBasicEmail({
        email,
        subject,
        text,
      });

      await updateDocument(["esg-survey", respondentId], {
        validationEmailSent: true,
      });
    } catch (e) {
      console.log(e);
    }
  };

  return {
    sendEsgEmail,
    sendEsgContactEmail,
    sendEsgSubmittedForValidationEmail,
  };
};

export default useEsgEmails;
